import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import React from 'react';

const MainPage: React.FC = () => {
    return (
        <LoadingWrapper loading={false}>
            <Title text="Hello World" level={1} />
        </LoadingWrapper>
    );
};

export default MainPage;
